// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2oBiv","alertIcon":"ConfirmModal_alertIcon__12dlF"};